/**
 * Gets the locale currently set for the website as a code.
 * Defaults to British English.
 */
export function getLocale(): string {
	const localeElement = document.querySelector('meta[name="locale"]');

	let localeCode: string | null = "en-GB";

	if (localeElement != null) {
		localeCode = localeElement.getAttribute('content');
	}

	return localeCode!;
}

/**
 * Gets the isProduction flag set.
 * Note this could be manipulated by a user, so do not put anything sensitive behind this flag.
 */
export function getIsProduction(): boolean {
	const isProductionElement = document.querySelector('meta[name="isProduction"]');

	let isProduction = false;

	if (isProductionElement != null) {
		const content = isProductionElement.getAttribute('content');

		isProduction = content == "true";
	}

	return isProduction;
}

/**
 * Gets whether the Aprimo integration is enabled.
 * Controlled server-side by the "Aprimo:Enabled" app setting, which renders
 * <meta name="aprimoEnabled" content="true" /> and the Aprimo SDK scripts when on.
 */
export function getIsAprimoEnabled(): boolean {
	const aprimoEnabledElement = document.querySelector('meta[name="aprimoEnabled"]');

	return aprimoEnabledElement?.getAttribute('content') == "true";
}
